import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { H5 } from 'components/typography/Headers';
import { useUserLocationChange } from 'features/my-profile/location/hooks/useUserLocationChange';
import { useCurrentUser } from 'providers/cache/cachedDataHooks';

import { LocationSubmitButton } from './LocationSubmitButton';
import { ZipInputField } from './ZipInputField';

const LocationInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 360px;
  margin-top: 24px;
`;

export const UserLocation = () => {
  const { currentUser, refreshCurrentUser } = useCurrentUser();
  const { t } = useTranslation();
  const { zipCode, handleZipChange, handleZipSubmit, isSubmitDisabled } = useUserLocationChange(refreshCurrentUser);

  return (
    <LocationInputContainer>
      <H5>{t('myProfile:location.input-header')}</H5>
      <ZipInputField
        zipCode={zipCode}
        onZipChange={handleZipChange}
        placeholder={t('myProfile:location.zip-placeholder')}
        cityName={currentUser?.location?.city}
      />
      <LocationSubmitButton
        onClick={handleZipSubmit}
        disabled={isSubmitDisabled}
        label={t('myProfile:location.set-location')}
      />
    </LocationInputContainer>
  );
};
